import { z } from "zod";

/** A retained transparent derivative; the enclosing assetId remains the original. */
export const backgroundRemovalSchema = z
  .object({
    version: z.literal(1),
    method: z.literal("cutaway-isnet-quint8"),
    assetId: z
      .string()
      .max(200)
      .regex(/^asset_[a-zA-Z0-9_-]+$/),
  })
  .strict();
export type BackgroundRemoval = z.infer<typeof backgroundRemovalSchema>;

export function backgroundRemoval(
  value: unknown,
): BackgroundRemoval | undefined {
  if (!value || typeof value !== "object" || Array.isArray(value)) return;
  const parsed = backgroundRemovalSchema.safeParse(
    (value as Record<string, unknown>).backgroundRemoval,
  );
  return parsed.success ? parsed.data : undefined;
}
